import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import StudiosPage from "@/pages/StudiosPage";
import CollectiblesPage from "@/pages/CollectiblesPage";
import ConsignmentsPage from "@/pages/ConsignmentsPage";
import ShopPage from "@/pages/ShopPage";
import BookStudioPage from "@/pages/BookStudioPage";
import ContactPage from "@/pages/ContactPage";
import ServiceDetail from "@/pages/ServiceDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AccountAuth from "@/pages/AccountAuth";
import AccountReset from "@/pages/AccountReset";
import AccountPortal from "@/pages/AccountPortal";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isAccount = pathname.startsWith("/account");
  const bare = isAdmin || isAccount;
  return (
    <>
      <div className="grain" aria-hidden="true" />
      {!bare && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/studios" element={<StudiosPage />} />
        <Route path="/collectibles" element={<CollectiblesPage />} />
        <Route path="/consignments" element={<ConsignmentsPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/book" element={<BookStudioPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/account/login" element={<AccountAuth />} />
        <Route path="/account/reset" element={<AccountReset />} />
        <Route path="/account" element={<AccountPortal />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerAuthProvider>
            <SmoothScroll>
              <Shell />
              <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                  style: {
                    background: "#121212",
                    border: "1px solid #27272a",
                    color: "#fafafa",
                    fontFamily: "Manrope, sans-serif",
                  },
                }}
              />
            </SmoothScroll>
          </CustomerAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
